import { Icon } from "@screencloud/screencloud-ui-components";
import { WrappedComponentProps, injectIntl } from "react-intl";
import { ScreenDisplay, StepperButton, StepperRow } from "./styles";

export interface ScreenCountStepperProps {
  screenCount: number;
  onDecrement: () => void;
  onIncrement: () => void;
  canDecrement: boolean;
}

const ScreenCountStepperBase = ({
  intl,
  screenCount,
  onDecrement,
  onIncrement,
  canDecrement,
}: ScreenCountStepperProps & WrappedComponentProps) => (
  <StepperRow>
    <StepperButton
      type="button"
      $position="start"
      onClick={onDecrement}
      disabled={!canDecrement}
      data-testid="screen-count-decrement"
      aria-label={intl.formatMessage({
        id: "pixi_wizard.screens.decrement_label",
        defaultMessage: "Decrease screen count",
      })}
    >
      <Icon name="minus" />
    </StepperButton>
    <ScreenDisplay
      data-testid="screen-count-display"
      aria-live="polite"
      aria-label={intl.formatMessage({
        id: "pixi_wizard.screens.input_label",
        defaultMessage: "Number of screens",
      })}
    >
      {screenCount}
    </ScreenDisplay>
    <StepperButton
      type="button"
      $position="end"
      onClick={onIncrement}
      data-testid="screen-count-increment"
      aria-label={intl.formatMessage({
        id: "pixi_wizard.screens.increment_label",
        defaultMessage: "Increase screen count",
      })}
    >
      <Icon name="plus" />
    </StepperButton>
  </StepperRow>
);

export const ScreenCountStepper = injectIntl(ScreenCountStepperBase);
